import { isString } from "lodash";

function capitalizeFirstLetter(string) {
  const str = string.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function hidePartString(string) {
  for (let i = 0; i < string.length - 4; i++) {
    string = string.replace(string[i], "·");
  }

  return string;
}

function hideApiKeys(apiKey) {
  const strArr = apiKey.split("-");
  strArr[1] = "····";
  strArr[2] = "····";
  strArr[3] = "····";
  strArr[4] = hidePartString(strArr[4]);

  return strArr.join("-");
}

function middleTruncate(string) {
  if (!string) return "";
  const before = string.substring(0, 6);
  const after = string.substring(string.length - 4);

  return `${before}...${after}`;
}

function stringArrayToOptionsArray(arr = []) {
  return arr.map((item) => ({ value: item, label: item }));
}

function trimStringInObject(obj) {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: isString(value) ? value.trim() : value,
    }),
    {}
  );
}

export {
  capitalizeFirstLetter,
  hideApiKeys,
  middleTruncate,
  stringArrayToOptionsArray,
  trimStringInObject,
};
